export const HomeObjectOne = {
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headline: "Hello, Hey there !!",
  description:
    "Fun Fact : There are 10 types of people in the world: those who understand binary, and those who don't.",
  descriptionLineTwo:
    "",
  primary: true,
  buttonLabel: "Let's code along !",
  imgStart: "",
  img: require("../../images/introimage.svg").default,
  alt: "Programmer",
  start: "",
  id: "landing-page"
};

export const HomeObjectTwo = {
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: "",
  headline: "So, who am I ?",
  description:
    "I am Bhupesh Patil, a software engineer with 2 years of professional experience at Larsen & Toubro, currently pursuing my MS in CS at Northeastern University. In my previous role, I was responsible for developing and maintaining web applications using Spring Boot, React, and AWS. My passion for software engineering, combined with my technical acumen and propensity for continuous learning, make me an ideal candidate for an internship opportunity in summer 2023.",
  descriptionLinetwo:
    "My strong work ethic and proclivity for adapting to change allow me to thrive in dynamic and challenging environments. I am confident that my expertise and enthusiasm make me a valuable asset to any team and I am eager to apply my skills and learn from new colleagues.",
  descriptionLineThree:
    "",
  primary: false,
  buttonLabel: "Let's code along !",
  imgStart: "start",
  img: require("../../images/IMG_1277.jpg").default,
  alt: "Programmer",
  start: "true",
  skills: true,
  linetwo: true,
  linethree: true,
  id: "about-page",
};

export const FooterObject = {
  id: "footer-page",
  subHeading:
    "Now we are talking ! Thankyou for your valuable time here. You can reach me out on any of the contact medium given below.",
  projectInformation: "Also, You can find all the projects on my github !",
  contact: {
    title: "Contact Me",
    linkedIn: " LinkedIn",
    github: " Github",
    gmail: " Mail",
    instagram: "Instagram",
    facebook: "Facebook",
    youtube: "YouTube",
  },
  disclaimer: "Bhupesh Patil © 2023",
};

export const socialMediaLink = {
  instagram: "https://www.instagram.com/bhupesh_patil_/",
  facebook: "https://www.facebook.com/bhupesh.patil.779/",
  linkedIn: "https://www.linkedin.com/in/bhupesh-patil-099926164/",
  github: "https://github.com/Bhupesh22",
  youtube: "https://www.youtube.com/watch?v=A20vlHzG-ek",
  gmail: "mailto:patil.bhu@northeastern.edu",
  resume:
    "https://drive.google.com/file/d/161lMt0jO5tnRsZwB56ciGFK3qyrIxKl3/view?usp=share_link",
};

export const ProjectObject = {
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  headline: "My Projects",
  animate: true,
  id: "project-page",
};

export const ProjectEndObject = {
  lightBg: false,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  headline: "",
  topLine: "Remaining projects on github . Check out !",
  animate: false,
};

export const ProjectLinks = {
  realtime:
    "https://github.com/Bhupesh22/Real-time-traffic-sign-detection-and-classification-with-voice-feedback",
  realtimepublication: "https://www.irjet.net/archives/V7/i4/IRJET-V7I4226.pdf",
  realtimeyoutube: "https://www.youtube.com/watch?v=A20vlHzG-ek",
};

export const ProjectObjectOne = {
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine:
    "Technologies : Python3.6, OpenCV, YoloV3 Object Detection, Google-Text-To-Speech (gTTS)",
  headline:
    "Real time traffic sign detection and classification with voice feedback",
  description:
    "The project focuses on detecting & recognizing traffic signs on the road while driving . Along with that providing an assistance to driver in the form of voice feedback using Google-Text-To-Speech. This project was made as a part of your final year project with team size of 3 (Bhupesh Patil (me), Akshay Naikwadi, Hitisha Pichad).",
  primary: false,
  imgStart: "",
  img: require("../../images/project-one-img.jpg").default,
  alt: "Programmer",
  start: "",
  project: true,
  labelOne: true,
  labelTwo: true,
  labelThree: true,
  projectButtonLabelOne: "View code </>",
  projectButtonLabelTwo: "View demo ",
  projectButtonLabelThree: "View publication",
  gitlink:
    "https://github.com/Bhupesh22/Real-time-traffic-sign-detection-and-classification-with-voice-feedback",
  realtimepublication: "https://www.irjet.net/archives/V7/i4/IRJET-V7I4226.pdf",
  deploylink: "https://www.youtube.com/watch?v=A20vlHzG-ek",
};

export const ProjectObjectTwo = {
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine:
    "Technologies : Python3.6, Flask, sense2vec, SpaCy TextCategorizer, GCP (for hosting)",
  headline: "Amazon food review analysis using NLP",
  description:
    "The project focuses on classifying user reviews for food into positive and negative category. It starts with Tokenization, POS Tagging, Lemmatization,Named Entity Recognition (NER) , Later sense2vec is used for deriving word vectors and caculating similarity",
  primary: true,
  imgStart: "start",
  img: require("../../images/project-two-img.svg").default,
  alt: "Programmer",
  project: true,
  labelOne: true,
  labelTwo: false,
  labelThree: false,
  projectButtonLabelOne: "View code </>",
  projectButtonLabelTwo: "View demo ",
  projectButtonLabelThree: "View publication",
  gitlink: "https://github.com/Bhupesh22/NLP-Amazon-Fine-Food-Review-Analaysis",
};

export const ProjectObjectThree = {
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine:
    "Technologies : ASP.NET Web API, Angular, MSSQLSERVER, Bootstrap4.0, Botpress (Chatbot)",
  headline: "Shoppify (Online Shopping)",
  description:
    "This is a full stack project completed within 7 days of duration during project gladiator phase in LTI. The project has team size of 4. Bhupesh Patil (Me: TeamLead), Swapnali Kadam, Srujana Kotur, Arnab Choudhary.",
  descriptionLinetwo:
    "Shoppify is developed for the customer/ users to buy the product and for retailer to upload the project details. Customer/ User is able to get his invoice & Retailer is able to get his total income. Chatbot is desgined for the ease of customers to get the latest offers on products and bank discounts. Filter (Search and Catgeory with price range), OTP based Retailer approval & forgot password features are also included",
  primary: false,
  imgStart: "",
  img: require("../../images/project-three-img.svg").default,
  alt: "Programmer",
  start: "",
  linetwo: true,
  project: true,
  labelOne: true,
  labelTwo: false,
  labelThree: false,
  projectButtonLabelOne: "View code </>",
  projectButtonLabelTwo: "View demo ",
  projectButtonLabelThree: "View publication",
  gitlink: "https://github.com/Bhupesh22/FrontEndShoppify",
};

export const ProjectObjectFour = {
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine:
    "Technologies : React, Redux, styled-components, Firebase Auth, Firebase CloudStorage, Firebase Hooks",
  headline: "Slack-Clone using React",
  description:
    "The project is the clone of the slack application. This is developed using react-app & firebase. Messages are stored on firebase cloud storage along with the chat rooms. Authentication is provided using Firebase Auth. Users can chat in any of the rooms that are provided",
  primary: true,
  imgStart: "start",
  img: require("../../images/project-four-img.svg").default,
  alt: "Programmer",
  project: true,
  labelOne: true,
  labelTwo: true,
  labelThree: false,
  projectButtonLabelOne: "View code </>",
  projectButtonLabelTwo: "View demo ",
  projectButtonLabelThree: "View publication",
  gitlink: "https://github.com/Bhupesh22/Slack-App",
  deploylink: "https://slack-clone-71691.web.app/",
};
